import { TEAM_USERS } from './queries/Team';
import { UserOrderByFields, OrderDirection } from './schema/schema';

export const TEAM_USERS_REFETCH = {
  query: TEAM_USERS,
  variables: {
    filters: {
      orderBy: UserOrderByFields.FirstName,
      orderDirection: OrderDirection.Asc,
    },
  },
};
